module.exports = __webpack_public_path__ + "static/bentonsans-bold-webfont-3519de83a4ffb2ddb5a01d05744c63bd.woff2";